export default {
    computed: {
        teamData() {
            return this.$store.state.teamData.teamData || {
                players: [],
                teams: [],
                misc: {}
            }
        }
    }
}